/* NRN Tactile: lightweight, accessible section reveal. No cart/checkout intercepts. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const seen = new WeakSet();
  const observer = !reduced && 'IntersectionObserver' in window
    ? new IntersectionObserver((items, obs) => {
        items.forEach((item) => {
          if (!item.isIntersecting) return;
          item.target.classList.add('nrn-motion-in');
          obs.unobserve(item.target);
        });
      }, { rootMargin: '0px 0px -30px 0px', threshold: 0.1 })
    : null;
  const init = (root = document) => {
    if (!observer) return;
    root.querySelectorAll('.nrn-editorial [data-nrn-reveal]').forEach((node) => {
      if (seen.has(node)) return;
      seen.add(node);
      node.classList.add('nrn-motion-pending');
      observer.observe(node);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
/* NRN Video controls. Autoplay must be muted; sound is available after user interaction. */
(() => {
  const attached = new WeakSet();
  function connect(root=document){
    const wrappers = [];
    if(root.matches?.(".nrn-film"))wrappers.push(root);
    wrappers.push(...root.querySelectorAll(".nrn-film"));
    for(const wrapper of wrappers){
      if(attached.has(wrapper))continue;
      const video=wrapper.querySelector("video");
      const sound=wrapper.querySelector("[data-nrn-film-sound]");
      const toggle=wrapper.querySelector("[data-nrn-film-play]");
      if(!video||!sound||!toggle)continue;
      attached.add(wrapper);
      video.removeAttribute("controls");
      video.playsInline=true;
      video.muted=true;
      const sync=()=>{
        sound.innerHTML=video.muted ? 'SOUND ON <span aria-hidden="true">♪</span>' : 'SOUND OFF <span aria-hidden="true">♪</span>';
        sound.setAttribute("aria-pressed",String(!video.muted));
        toggle.innerHTML=video.paused ? 'PLAY <span aria-hidden="true">▶</span>' : 'PAUSE <span aria-hidden="true">Ⅱ</span>';
        toggle.setAttribute("aria-pressed",String(!video.paused));
      };
      sound.addEventListener("click",()=>{
        video.muted=!video.muted;
        if(video.paused)video.play().catch(()=>{});
        sync();
      });
      toggle.addEventListener("click",()=>{
        if(video.paused)video.play().catch(()=>{});
        else video.pause();
        sync();
      });
      video.addEventListener("play",sync);
      video.addEventListener("pause",sync);
      video.addEventListener("volumechange",sync);
      if(window.matchMedia("(prefers-reduced-motion: reduce)").matches)video.pause();
      sync();
    }
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>connect(),{once:true});
  else connect();
  document.addEventListener("shopify:section:load",(event)=>connect(event.target));
})();
